module.exports = __webpack_public_path__ + "static/small-shape-9e5860406721c408d394cd0d8d591638.gif";